import { Button, FormControlLabel, Switch, Typography } from '@material-ui/core';
import { useTheme, withStyles } from '@material-ui/core/styles';
import React from 'react';

// const useStyles = makeStyles(theme => ({
//   highlight: {
//     color: theme.palette.link.main,
//     textDecoration: 'underline',
//     cursor: 'pointer'
//   }
// }))
const CustomSwitch = withStyles(theme => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid #FFF`,
    backgroundColor: theme.palette.grey[300],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const ToggleButton = ({ text, value, checked, onClick }) => {
  // const classes = useStyles()
  const theme = useTheme()
  return (
    <Button variant="contained" style={
        {color: (checked ? theme.palette.common.white : theme.palette.primary.main), 
        backgroundColor: (checked ? theme.palette.primary.main : theme.palette.grey[300]), 
        whiteSpace: 'nowrap',
        padding: '0px 8px',
        fontWeight: 500,
        borderRadius: 40}
      }>
        <FormControlLabel
          control={
            <CustomSwitch
              value={value}
              checked={checked}
              onChange={onClick} />
          }
          label={<Typography variant="button" style={{fontWeight: 500}}>{text || "Played Together"}</Typography>}
          labelPlacement="start"
        />
    </Button>
  )
}

export default ToggleButton
